/*
  Shoes Egy — live cart count in the header.

  Dawn refreshes the count by re-rendering #cart-icon-bubble through the Section
  Rendering API. This header does not use that element, so the number only ever
  changed on a page load. Subscribe to Dawn's own cartUpdate event instead and
  write the count straight into both header instances.

  Payloads differ by source: cart.js publishes the parsed cart, which carries
  item_count, while product-form.js publishes the /cart/add.js response, which
  does not. So take item_count when it is there and ask /cart.js when it is not,
  rather than trusting one shape.
*/
(function () {
  var FLASH_MS = 1000;

  function counts() {
    return document.querySelectorAll('.shoes-icon-count');
  }

  function cartLinks() {
    return document.querySelectorAll('.shoes-icon-link--cart');
  }

  function render(count, flash) {
    if (typeof count !== 'number' || isNaN(count)) return;

    counts().forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('is-empty', count <= 0);
    });

    if (!flash) return;

    cartLinks().forEach(function (link) {
      link.classList.remove('is-updated');
      // restart the state even if two adds land close together
      void link.offsetWidth;
      link.classList.add('is-updated');
      window.setTimeout(function () {
        link.classList.remove('is-updated');
      }, FLASH_MS);
    });
  }

  function fromCart(flash) {
    var url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (cart) render(cart.item_count, flash);
      })
      .catch(function () {
        /* leave the last known count in place */
      });
  }

  function onCartUpdate(event) {
    var flash = !event || event.source !== 'cart-items';
    var data = event && event.cartData;

    if (data && typeof data.item_count === 'number') {
      render(data.item_count, flash);
      return;
    }
    fromCart(flash);
  }

  function start() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    return true;
  }

  // pubsub.js is deferred in <head> and this file is deferred in the header
  // section, so it has normally run already; fall back for the case where it
  // has not.
  if (!start()) {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
